module.exports = "/images/np.svg?16467aa317c6cd948e75483b2d0cbbc2";